import apiService, { apiServiceExternal } from '../apiService'
import { POST } from '../apiService'

const apiPath = '/policy'
const urlTaskbackend = 'https://taskbackend-fin-insurance.com'

export const policyController = (configService) => {
	const service = apiService(configService)
	const serviceExternal = apiServiceExternal(configService)

	return {
		intraPrbV3: (params) => {
			const headers = {
				'x-api-key':
					'8b611f8f162aa3e8aeccdc752141fecbc0e1bb91c5473761e2fd1e21f8e73897',
			}
			return POST({
				url: `${urlTaskbackend}/warranty/api/v1/insurance/intra-cmi`,
				body: { ...params, api_company_type: 'intra_v2_cmi', send_from: 'ตรอ' },
				headers,
			})
		},
		intraInsure: (params) => {
			const headers = {
				'x-api-key':
					'8b611f8f162aa3e8aeccdc752141fecbc0e1bb91c5473761e2fd1e21f8e73897',
			}
			return POST({
				url: `${urlTaskbackend}/warranty/api/v1/insurance/intra-vmi`,
				body: { ...params, api_company_type: 'intra_vmi', send_from: 'ตรอ' },
				headers,
			})
		},
		intraPrbCancel: (params) => {
			const headers = {
				'x-api-key':
					'8b611f8f162aa3e8aeccdc752141fecbc0e1bb91c5473761e2fd1e21f8e73897',
			}
			return POST({
				url: `${urlTaskbackend}/warranty/api/v1/insurance/cancel-intra-cmi`,
				body: { ...params, send_from: 'ตรอ' },
				headers,
			})
		},
		intraInsureCancel: (params) => {
			const headers = {
				'x-api-key':
					'8b611f8f162aa3e8aeccdc752141fecbc0e1bb91c5473761e2fd1e21f8e73897',
			}
			return POST({
				url: `${urlTaskbackend}/warranty/api/v1/insurance/intra-vmi-cancel`,
				body: { ...params, send_from: 'ตรอ' },
				headers,
			})
		},
		intraPrbDj: (params) => {
			return service.post({
				url: `${apiPath}/get_policy_prb_ins`,
				body: {
					...params,
					api_company_type: 'dj_iic',
					api_action: 'CallAPI_dj_iic_CMI',
					send_from: 'ตรอ',
				},
			})
		},
		chubbInsure: (params) => {
			const headers = {
				Authorization: 'admin-task02',
			}
			return POST({
				url: `${urlTaskbackend}/warranty/api/v1/insurance/chubb-vmi`,
				body: {
					...params,
					api_company_type: 'prod',
					send_from: 'ตรอ',
					policy_type: 'VMI',
				},
				headers,
			})
		},
		chubbPrb: (params) => {
			const headers = {
				Authorization: 'admin-task02',
			}
			return POST({
				url: `${urlTaskbackend}/warranty/api/v1/insurance/chubb-cmi`,
				body: {
					...params,
					api_company_type: 'prod',
					send_from: 'ตรอ',
					policy_type: 'CMI',
				},
				headers,
			})
		},
		axaPrb: (params) => {
			return service.post({
				url: `${apiPath}/get_policy_prb_ins`,
				body: {
					...params,
					api_company_type: 'axa',
					api_action: 'CallAPI_axa_CMI',
					send_from: 'ตรอ',
				},
			})
		},
		axaInsure: (params) => {
			return service.post({
				url: `${apiPath}/get_policy_prb_ins`,
				body: {
					...params,
					api_company_type: 'axa',
					api_action: 'CallAPI_axa_VMI',
					send_from: 'ตรอ',
				},
			})
		},
		kumpaiPrb: (params) => {
			return service.post({
				url: `${apiPath}/createKumpaiCMIPolicy`,
				body: { ...params, api_company_type: 'kumpai_cmi', send_from: 'ตรอ' },
			})
		},
		kumpaiInsure: (params) => {
			return service.post({
				url: `${apiPath}/createKumpaiCOVPolicy`,
				body: { ...params, api_company_type: 'kumpai_vmi', send_from: 'ตรอ' },
			})
		},
		viriyaPrb: (params) => {
			const headers = {
				Authorization: 'admin-task02',
			}
			return POST({
				url: `${urlTaskbackend}/warranty/api/v1/insurance/viriya-cmi`,
				body: { ...params, api_company_type: 'prod', send_from: 'ตรอ' },
				headers,
			})
		},
		viriyaInsure: (params) => {
			const headers = {
				Authorization: 'admin-task02',
			}
			return POST({
				url: `${urlTaskbackend}/warranty/api/v1/insurance/viriya-vmi`,
				body: { ...params, api_company_type: 'prod', send_from: 'ตรอ' },
				headers,
			})
		},
		tipPrb: (params) => {
			return service.post({
				url: `${apiPath}/get_policy_prb_ins`,
				body: { ...params, api_company_type: 'tip_cmi', send_from: 'ตรอ' },
			})
		},
		mtiPrb: (params) => {
			return service.post({
				url: `${apiPath}/get_policy_prb_ins`,
				body: { ...params, api_company_type: 'mti_cmi', send_from: 'ตรอ' },
			})
		},
		mtiInsure: (params) => {
			return service.post({
				url: `${apiPath}/get_policy_prb_ins`,
				body: {
					...params,
					api_company_type: 'mti_vmi',
					send_from: 'ตรอ',
				},
			})
		},
		jaymartPrb: (params) => {
			return service.post({
				url: `${apiPath}/get_policy_prb_ins`,
				body: { ...params, api_company_type: 'jmt_cmi', send_from: 'ตรอ' },
			})
		},
		thaisriPrb: (params) => {
			return service.post({
				url: `${apiPath}/get_policy_prb_ins`,
				body: {
					...params,
					api_company_type: 'dj_tsri',
					api_action: 'CallAPI_dj_tsri_CMI',
					send_from: 'ตรอ',
				},
			})
		},
		thaisriInsure: (params) => {
			return service.post({
				url: `${apiPath}/get_policy_prb_ins`,
				body: {
					...params,
					api_company_type: 'tsi',
					api_action: 'CallAPI_tsi_VMI',
					send_from: 'ตรอ',
				},
			})
		},
		thaisriPrbInsure: (params) => {
			return service.post({
				url: `${apiPath}/get_policy_prb_ins`,
				body: {
					...params,
					api_company_type: 'tsi',
					api_action: 'CallAPI_tsi_CMI_VMI',
					send_from: 'ตรอ',
				},
			})
		},
		dhipayaInsure: (params) => {
			return service.post({
				url: `${apiPath}/get_policy_prb_ins`,
				body: { ...params, api_company_type: 'tip_vmi', send_from: 'ตรอ' },
			})
		},
		thaiSetakijPrb: (params) => {
			return service.post({
				url: `${apiPath}/get_policy_prb_ins`,
				body: { ...params, api_company_type: 'tsi_cmi', send_from: 'ตรอ' },
			})
		},
		thaiSetakijPrbCancel: (params) => {
			return service.post({
				url: `${apiPath}/get_policy_prb_ins`,
				body: {
					...params,
					policy_type: 'CMI',
					api_company_type: 'tsi_cancel',
				},
			})
		},
		kwiPrb: (params) => {
			return service.post({
				url: `${apiPath}/get_policy_prb_ins`,
				body: {
					...params,
					api_company_type: 'kwi',
					// api_company_type: 'kwi_uat',
					api_action: 'CallAPI_kwi_CMI',
					send_from: 'ตรอ',
				},
			})
		},
		kwiInsure: (params) => {
			return service.post({
				url: `${apiPath}/get_policy_prb_ins`,
				body: {
					...params,
					api_company_type: 'kwi',
					// api_company_type: 'kwi_uat',
					api_action: 'CallAPI_kwi_VMI',
					send_from: 'ตรอ',
				},
			})
		},
		ddPrb: (params) => {
			return service.post({
				url: `${apiPath}/get_policy_prb_ins`,
				body: {
					...params,
					api_company_type: 'dj',
					// api_company_type: 'dj_uat',
					api_action: 'CallAPI_dj_CMI',
					send_from: 'ตรอ',
				},
			})
		},
		rvpPrb: (params) => {
			return service.post({
				url: `${apiPath}/get_policy_prb_ins`,
				body: {
					...params,
					api_company_type: 'dj_rvp',
					// api_company_type: 'dj_rvp_uat',
					api_action: 'CallAPI_dj_rvp_CMI',
					send_from: 'ตรอ',
				},
			})
		},
		fciPrb: (params) => {
			return service.post({
				url: `${apiPath}/get_policy_prb_ins`,
				body: {
					...params,
					api_company_type: 'dj_fci',
					// api_company_type: 'dj_fci_uat',
					api_action: 'CallAPI_dj_fci_CMI',
					send_from: 'ตรอ',
				},
			})
		},
		fciInsure: (params) => {
			return service.post({
				url: `${apiPath}/get_policy_prb_ins`,
				body: {
					...params,
					api_company_type: 'dj_fci',
					// api_company_type: 'dj_fci_uat',
					api_action: 'CallAPI_dj_fci_VMI',
					send_from: 'ตรอ',
				},
			})
		},
		tpbInsure: (params) => {
			const headers = {
				Authorization: 'admin-task02',
				'Content-Type': 'application/json',
			}
			return POST({
				url: `${urlTaskbackend}/warranty/api/v1/insurance/tpb-vmi`,
				body: {
					...params,
					api_company_type: 'tpb',
					api_action: 'CallAPI_tpb_VMI',
					send_from: 'ตรอ',
				},
				headers,
			})
		},
		dvsPrb: (params) => {
			const headers = {
				Authorization: 'admin-task02',
				'Content-Type': 'application/json',
			}
			return POST({
				url: `${urlTaskbackend}/warranty/api/v1/insurance/dj-dvs-cmi`,
				body: {
					...params,
					api_company_type: 'prod',
					policy_type: 'CMI',
					send_from: 'ตรอ',
				},
				headers,
			})
		},
		dvsInsure: (params) => {
			const headers = {
				Authorization: 'admin-task02',
				'Content-Type': 'application/json',
			}
			return POST({
				url: `${urlTaskbackend}/warranty/api/v1/insurance/dj-dvs-vmi`,
				body: {
					...params,
					api_company_type: 'prod',
					policy_type: 'VMI',
					send_from: 'ตรอ',
				},
				headers,
			})
		},
	}
}
